/**
 * Northern Row Hub
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MarketingFileType = 'BeerCans' | 'BeerDraught' | 'Spirits';

export const MarketingFileType = {
    BeerCans: 'BeerCans' as MarketingFileType,
    BeerDraught: 'BeerDraught' as MarketingFileType,
    Spirits: 'Spirits' as MarketingFileType
};

